import React from "react";
import alarm from "../img/ico-alarm-ep.svg";

export default class AssignmentListItem extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      buttonClass: ""
    };
  }

  /**
   * React lifecycle method.
   * Sets the button class and urgent mobile class in state based on assignment data
   * after the component mounts.
   */

  componentDidMount = () => {

    // this is used to give the correct class to the buttons
    let buttonClass;
    switch (this.props.data.startbuttonstatus) {
      case 1:
        buttonClass = "success";
        break;
        case 2:
        case 5:
        case 3:
        buttonClass = "primary";
        break;
      default:
        buttonClass = "";
    }

    this.setState({
      buttonClass: buttonClass,
    });

  };

  /**
   * Returns the correct URL for the "Start" button based on the assignment's status.
   * @returns {string|null} The URL to start the assignment, or null if not available.
   */

  getStartButtonUrl = () => {

    return "/osa/a=" + this.props.data.assignmentkey;
  };

  /**
   * Renders the assignment list item.
   * Displays assignment details, urgency, time, and action buttons.
   * If no assignment data is present, shows a message to the user.
   * @returns {JSX.Element}
   */
  render() {
    const { data } = this.props;
    return (
      this.props.data ?
        <li className="col-md-12 assignment-block list-view">
          <div className="AssignmentListItem row list-view">
            {data.isnew ?
              <span className="badge bg- badge-new">New!</span>
              : null}
            <div className="col-md-4 assignment-title-wrap">
              <div className={`assignment-title row`}>
                <div className={`subject-icons circle-${data.docsubject}`}>
                  <i className={`subject-icon ${data.docsubject}`} />
                </div>
                <div className="title-assesstitle">
                  <h2>{data.title}</h2>
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className={`assignment-time row`}>
                {data.urgent ?
                  <div className="col-sm-3 clock-container">
                    <img alt="alarm-clock" className="alarm-clock" src={alarm} />
                  </div>
                  : null}

                <div className="col-sm-8">
                  <p className="timetext">{data.urgent ? <img alt="alarm-clock" className="alarm-clock-mobile" src={alarm} />
                    : null}<span>{data.timetext}</span></p>
                  <p>{data.fixedduration ? "Time allowed" : "Time suggested"}: <strong>{data.duration} mins</strong></p>
                </div>
              </div>
            </div>
            <div className={`col-md-1 assignment-status ${data.status}`}>
              <p className={`${data.status}`}>{data.status}</p>
            </div>
            <div className={`col-md-2 assignment-action-buttons`}>

              {data.startbuttonstatus !== 4 ?
                <a href={data.startbuttonurl}
                  className={`btn btn-${this.state.buttonClass}`} role="button"
                  target={this.props.isMobile ? "_self" : "_blank"} rel="noreferrer">{data.startbuttontext}</a>
                : ''}

            </div>
          </div>
        </li>
        : <p className="noAssignments">You have no assignments to complete yet. Speak to your teacher or come back later.</p>

    );
  }
}
